import NewConsumerPopUp from "./newConsumerPopup.container";

export default NewConsumerPopUp;
